import { SECRET_KEY } from "../store/constants";

/**
 * Password validator for login pages
 */
// has number
const hasNumber = (number) => new RegExp(/[0-9]/).test(number);

// has mix of small and capitals
const hasMixed = (number) => new RegExp(/[a-z]/).test(number) && new RegExp(/[A-Z]/).test(number);

// has special chars
const hasSpecial = (number) => new RegExp(/[!#@$%^&*)(+=._-]/).test(number);

// set color based on password strength
export const strengthColor = (count) => {
  if (count < 2) return { label: "Poor", color: "#f44336" };
  if (count < 3) return { label: "Weak", color: "#ffc107" };
  if (count < 4) return { label: "Normal", color: "#ffab91" };
  if (count < 5) return { label: "Good", color: "#00e676" };
  if (count < 6) return { label: "Strong", color: "#00c853" };
  return { label: "Poor", color: "#f44336" };
};

// password strength indicator
export const strengthIndicator = (number) => {
  let strengths = 0;
  if (number.length > 5) strengths += 1;
  if (number.length > 7) strengths += 1;
  if (hasNumber(number)) strengths += 1;
  if (hasSpecial(number)) strengths += 1;
  if (hasMixed(number)) strengths += 1;
  return strengths;
};

export function formatMobile(mobile) {
  mobile = mobile?.toString();
  if (mobile?.length === 0) {
    mobile = "";
  } else if (mobile?.length < 10) {
    // mobile = mobile;
  } else if (mobile?.length === 10 && mobile[0] === "1") {
    mobile = mobile?.replace(/^(\d{0,2})/, "(880) $1 ");
  } else if (mobile?.length > 10) {
    mobile = mobile.replace(/^00880|^\+880|^880/, "880");
    mobile = mobile?.replace(/^(\d{0,3})(\d{0,2})/, "($1) $2 ");
  }

  return mobile;
}

// fromat comma separeted mobile number string to 880XXxxxxxxx format string
export function formatMobileNumberString(numberString) {
  numberString = numberString?.toString();
  let formatedNumberString = "";
  if (numberString !== "" && numberString.length >= 10) {
    formatedNumberString = numberString
      .split(",")
      .map((number) => {
        if (number.startsWith("1")) {
          return "(880)" + number;
        }
        if (number.startsWith("0")) {
          return "(880)" + number.substring(1);
        }
        return number.replace(/^00880|^\+880|^880/, "(880)");
      })
      .join(",");
  }

  return formatedNumberString;
}

export function currencyFormat(num, unit, fractionDigits) {
  return unit + num?.toFixed(fractionDigits).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

export function longTextShow(text, maxLength) {
  return text.length > maxLength ? text.substring(0, maxLength - 3) + "..." : text;
}

export function findCampaignStatus(status) {
  let statusName;
  let statusColor;

  switch (status) {
    case 0:
      statusName = "Pending";
      statusColor = "info.main";
      break;
    case 1:
      statusName = "Running";
      statusColor = "primary.main";
      break;
    case 2:
      statusName = "Completed";
      statusColor = "success.main";
      break;
    case 3:
      statusName = "Processing";
      statusColor = "warning.dark";
      break;
    // case 4:
    //   statusName = "Modified";
    //   statusColor = "secondery.main";
    //   break;
    case 5:
      statusName = "Paused";
      statusColor = "warning.main";
      break;
    case 6:
      statusName = "Expired";
      statusColor = "error.dark";
      break;
    case 7:
      statusName = "Stopped";
      statusColor = "error.main";
      break;
    case 10:
      statusName = "1st Approve Pending";
      statusColor = "warning.main";
      break;
    case 11:
      statusName = "1st Approve Rejected";
      statusColor = "error.main";
      break;
    case 12:
      statusName = "2nd Approve Pending";
      statusColor = "warning.main";
      break;
    case 13:
      statusName = "2nd Approve Rejected";
      statusColor = "error.main";
      break;
    case 14:
      statusName = "Processing";
      statusColor = "warning.dark";
      break;
    case 15:
      statusName = "Processing";
      statusColor = "warning.dark";
      break;
    case 16:
      statusName = "Processing";
      statusColor = "warning.dark";
      break;
    default:
      statusName = "-";
      statusColor = "inherit";
      break;
  }

  return { status: statusName, color: statusColor };
}


export function findNumberStatus(status) {
  let statusName;
  let statusColor;

  switch (status) {
    case 0:
      statusName = "Pending";
      statusColor = "warning.main";
      break;
    case 1:
      statusName = "Successfully Submitted";
      statusColor = "success.main";
      break;
    case 2:
      statusName = "Failed due to system TPS";
      statusColor = "error.main";
      break;
    case 3:
      statusName = "Failed by Operator";
      statusColor = "error.main";
      break;
    case 4:
      statusName = "Successfully Delivered";
      statusColor = "success.main";
      break;
    case 5:
      statusName = "Delivery Failed";
      statusColor = "error.main";
      break;
    case 6:
      statusName = "Processing";
      statusColor = "warning.main";
      break;
    default:
      statusName = "-";
      statusColor = "inherit";
      break;
  }

  return { status: statusName, color: statusColor };
}


export function getTimeWelcome() {
  const hours = new Date().getHours();

  if (+hours < 12) {
    return "Good Morning!";
  } else if ((+hours > 12 && +hours < 16) || +hours === 12) {
    return "Good Afternoon!";
  } else {
    return "Good Evening!";
  }
}

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export function stringAvatar(name) {
  if (name !== " ") {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: name?.split(" ").length > 1 ? `${name?.split(" ")[0][0]}${name?.split(" ")[1][0]}` : name?.split(" ")[0][0],
    };
  }
}

const CryptoJS = require("crypto-js");

export function encrypt(cipherText) {
  if (cipherText) {
    return CryptoJS.AES.encrypt(JSON.stringify(cipherText), SECRET_KEY).toString();
  }
}

export function decrypt(cipherText) {
  if (cipherText) {
    let bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
}

export const _setImage = async (src, filename) => {
  try {
    if (src) {
      return await fetch(src)
        .then((r) => r.blob())
        .then((blobFile) => new File([blobFile], filename, { type: blobFile.type }));
    } else {
      return {};
    }
  } catch (error) {
    console.log(error);
    return {};
  }
};

export const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export function getSalaryRange(val) {
  let range;
  switch (val) {
    case 0:
      range = "Between Rs. 100,000 & Rs. 200,000";
      break;
    case 1:
      range = "Between Rs. 200,000 & Rs. 300,000";
      break;
    case 2:
      range = "Above Rs. 300,000";
      break;
    default:
      range = "inavlid";
  }

  return range;
}

export function getIncomeType(val) {
  let type;
  switch (val) {
    case 0:
      type = "Salaried Employee";
      break;
    case 1:
      type = "Other Income";
      break;
    default:
      type = "inavlid";
  }

  return type;
}

export function getEmployeeType(val) {
  let type;
  switch (val) {
    case 0:
      type = "Permanent";
      break;
    case 1:
      type = "Contract";
      break;
    case 2:
      type = "Self Employed";
      break;
    default:
      type = "inavlid";
  }

  return type;
}

// message character count start here. import only messageCounterUpdate and pass the message
export function hasUnicode(str) {
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 127) {
      return true;
    }
  }
  return false;
}

// const setMessageLength = (message, msgDefaultSize) => {
//   let messageRemLength;
//   let numberOfMessages;

//   let msgTempLength = message.length;

//   let quotient = Math.floor(msgTempLength / msgDefaultSize);
//   let remainder = (msgTempLength - msgDefaultSize * quotient) % msgDefaultSize;
//   if (msgTempLength % msgDefaultSize === 0) {
//     if (msgTempLength === msgDefaultSize * quotient && msgTempLength !== 0) {
//       messageRemLength = 0;
//       numberOfMessages = quotient;
//     } else {
//       messageRemLength = msgDefaultSize - remainder;
//       numberOfMessages = quotient;
//     }
//   } else {
//     messageRemLength = msgDefaultSize - remainder;
//     numberOfMessages = quotient + 1;
//   }
//   //setting number of messages to 1 when ever message box is empty
//   if (message.length === 0) {
//     numberOfMessages = 1;
//   }

//   return {
//     messageRemLength: messageRemLength,
//     numberOfMessages: numberOfMessages,
//   };
// };

export const messageCounterUpdate = (message, messageLength) => {
  if (message) {
    if (hasUnicode(message)) {
      return message.length > messageLength.unicode ? 0 : messageLength.unicode - message.length;
      // return setMessageLength(message, messageLength.unicode);
    } else {
      return message.length > messageLength.non_unicode ? 0 : messageLength.non_unicode - message.length;
      // return setMessageLength(message, messageLength.non_unicode);
    }
  } else {
    return message.length > messageLength.non_unicode ? 0 : messageLength.non_unicode - message.length;
    // return setMessageLength(message, messageLength.non_unicode);
  }
};

// character count function end here

export function htmlToString(ref) {
  let msg = ref.current.innerHTML;
  let textMsg;

  if (msg?.startsWith("<div>")) {
    textMsg = msg
      .replaceAll("</div><div>", "\n")
      .replaceAll('<div><span style="font-size: 1rem;">', "\n")
      .replaceAll("</span><div>", "\n")
      .replaceAll("<br>", "")
      .replaceAll("</div>", "")
      .replaceAll("<div>", "")
      .replaceAll("&amp;", "&")
      .replaceAll("&nbsp;", " ")
      .replaceAll(document.getElementById("img_col2")?.outerHTML, "#_MASK")
      // .replaceAll(document.getElementById("img_col2")?.outerHTML, "#ADA_BAN_VAR2")
      .replaceAll(document.getElementById("img_col3")?.outerHTML, "#_MASK")
      // .replaceAll(document.getElementById("img_col4")?.outerHTML, "#ADA_BAN_VAR4")
      // .replaceAll(document.getElementById("img_col5")?.outerHTML, "#ADA_BAN_VAR5")
      // .replaceAll(document.getElementById("img_col6")?.outerHTML, "#ADA_BAN_VAR6")
      .replaceAll(/(<([^>]+)>)/gi, "");
  } else {
    textMsg = msg
      .replace("<div>", "\n")
      .replaceAll("</div><div>", "\n")
      .replaceAll('<div><span style="font-size: 1rem;">', "\n")
      .replaceAll("</span><div>", "\n")
      .replaceAll("<br>", "")
      .replaceAll("</div>", "")
      .replaceAll("<div>", "")
      .replaceAll("&amp;", "&")
      .replaceAll("&nbsp;", " ")
      .replaceAll(document.getElementById("img_col2")?.outerHTML, "#_MASK")
      // .replaceAll(document.getElementById("img_col2")?.outerHTML, "#ADA_BAN_VAR2")
      .replaceAll(document.getElementById("img_col3")?.outerHTML, "#_MASK")
      // .replaceAll(document.getElementById("img_col4")?.outerHTML, "#ADA_BAN_VAR4")
      // .replaceAll(document.getElementById("img_col5")?.outerHTML, "#ADA_BAN_VAR5")
      // .replaceAll(document.getElementById("img_col6")?.outerHTML, "#ADA_BAN_VAR6")
      .replaceAll(/(<([^>]+)>)/gi, "");
  }

  // console.log(textMsg);

  return { textMsg: textMsg, msg: msg };
}

export const normalizeMessageContent = (message) => {
  return message
    .replace(/\u00A0/g, " ")  // Replace non-breaking space (&nbsp;)
    .replace(/\\n|\\r|\r\n|\r|\n/g, "\n") // Normalize new lines
    .replace(/\u200B/g, "")  // Remove zero-width space
    .replace(/\u2013/g, "-") // Replace en-dash with hyphen
    .replace(/\u2014/g, "--") // Replace em-dash with double hyphen
    .replace(/\u202F/g, " ") // Replace narrow no-break space
    .replace(/\u205F/g, " ") // Replace medium mathematical space
    .replace(/\u3000/g, " ") // Replace ideographic space (wide space in some languages)
    .replace(/\uFEFF/g, "")  // Remove byte order mark (BOM)
    .replace(/\u00AD/g, "")  // Remove soft hyphen
    .replace(/\u200E|\u200F/g, "") // Remove LTR & RTL marks
    .replace(/[\u2060\u2066-\u2069]/g, "") // Remove bidirectional control characters
    .replace(/[\u2028\u2029]/g, "") // Remove line separator & paragraph separator
    .replace(/(<([^>]+)>)/gi, "") // Remove HTML tags
    .replace(/\r?\n|\r/g, "\n") // Normalize line endings further
    .replace(/[\uFF01-\uFF5E]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xFEE0)); // Convert fullwidth ASCII to normal ASCII
};


export const general_character_array = [
  "@",
  "£",
  "$",
  "¥",
  "è",
  "é",
  "ù",
  "ì",
  "ò",
  "Ç",
  "\n",
  "Ø",
  "ø",
  "\r",
  "Å",
  "å",
  "Δ",
  "_",
  "Φ",
  "Γ",
  "Λ",
  "Ω",
  "Π",
  "Ψ",
  "Σ",
  "Θ",
  "Ξ",
  "Æ",
  "æ",
  "ß",
  "É",
  " ",
  "!",
  '"',
  "#",
  "¤",
  "%",
  "&",
  "'",
  "(",
  ")",
  "*",
  "+",
  ",",
  "-",
  ".",
  "/",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ":",
  ";",
  "<",
  "=",
  ">",
  "?",
  "¡",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "Ä",
  "Ö",
  "Ñ",
  "Ü",
  "§",
  "¿",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "ä",
  "ö",
  "ñ",
  "ü",
  "à",
  "\f",
  "^",
  "{",
  "}",
  "\\",
  "[",
  "~",
  "]",
  "|",
  "€",
];

export function deepEqualLoose(obj1, obj2) {
  // If both are strictly equal, return true
  if (obj1 === obj2) return true;

  // If either is null or not an object, return false (we ignore types)
  if (obj1 == null || obj2 == null || typeof obj1 !== "object" || typeof obj2 !== "object") {
    return obj1 === obj2; // Loose equality check (e.g., 1 == "1")
  }

  // Get object keys
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // If number of keys is different, objects are not equal
  if (keys1.length !== keys2.length) return false;

  // Compare each key and value in both objects
  for (let key of keys1) {
    if (!deepEqualLoose(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}
